import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import IsIBCInternetCustomerSliceReducer from './IsIBCInternetCustomerSlice';

export default class IsIBCInternetCustomeritializableModule implements IInitializableModule {
  protected name: string = 'IsIBCInternetCustomer module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
  }

  public StartModule(context: IEpiserverContext): void {
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'IsIBCInternetCustomer',
      reducer: IsIBCInternetCustomerSliceReducer,
    };
  }
}
